import React, { useEffect, useState } from "react";
import {
  fetchSuggestions,
  handleSelectSuggestion,
  handleTypedAdress,
} from "./AddressSearchAutocomplete.service";
import { ListItem, SearchField } from "@dishopsaas/design-system";
import { Paper } from "@mui/material";
import {
  AutocompleteSuggestionType,
  AddressSearchAutocompleteInputProps,
} from "../../../../1_types/AddressInputTypes";
import getStyles from "../../AddressInput.styles";

export default function AddressSearchAutocompleteInput({
  typedAddress,
  setTypedAddress,
  handleAddressSelection,
  handleAddressInputFormControlError,
  hasErrorAddressMessage,
  showShopsDropdownList,
  animatePlaceholder,
  isFilledAddressValid,
  lastTypedAddressValidValue,
  customerAddress,
}: AddressSearchAutocompleteInputProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const styles = getStyles()
  useEffect(() => {
    const timeoutId = setTimeout(
      () =>
        fetchSuggestions(
          typedAddress,
          isFilledAddressValid,
          setSuggestions,
          setIsLoading,
          handleAddressInputFormControlError,
          lastTypedAddressValidValue
        ),
      400
    );
    return () => clearTimeout(timeoutId);
  }, [typedAddress, isFilledAddressValid]);

  return (
    <>
      <div
        style={{
          position: "relative",
          marginTop: !customerAddress && "8px",
          width: "100%",
          marginBottom: !customerAddress && "16px",
        }}
      >
        <SearchField
          key={animatePlaceholder}
          value={typedAddress}
          onChange={(value) =>
            handleTypedAdress(value, setTypedAddress, setSuggestions)
          }
          placeholder={animatePlaceholder}
          validateAddress={isFilledAddressValid}
          error={hasErrorAddressMessage}
          clearable
          loading={isLoading}
          fullWidth
          size="medium"
        />

        {suggestions?.length > 0 && (
          <Paper
            sx={{
              position: showShopsDropdownList() ? "absolute" : "relative",
              ...styles.suggestionsPaper,
            }}
          >
            {suggestions.map((suggestion: AutocompleteSuggestionType) => (
              <div
                key={suggestion.placeId}
                onClick={() =>
                  handleSelectSuggestion(suggestion, handleAddressSelection)
                }
              >
                <ListItem
                  label={suggestion?.formattedSuggestion?.mainText}
                  description={suggestion?.formattedSuggestion?.secondaryText}
                  leftIcon="position"
                  reverse
                  iconSx={{ pr: 4 }}
                />
              </div>
            ))}
          </Paper>
        )}
      </div>
    </>
  );
}
